exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".returns_table{border:1px solid #ccc;border-top:none;overflow:auto}.returns_table table thead{color:#ffffff;text-transform:uppercase}.returns_table table thead tr{background-color:slategrey}.returns_table table tr{border-bottom:1px solid #ccc}.returns_table table tr:last-child{border-bottom:none}.returns_table table input{all:unset}.returns_table table tbody{color:#141414}.returns_table .returnsColum{width:50px}.returns_table .returnsColum input{width:50px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create/universe_lite/Analyze/returnsTable/returnsTable.style.scss
// module id = 831
// module chunks = 0